"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NonHtmlAnchorClickTracking = /** @class */ (function () {
    /**
     * Setup tracking of anchor link clicks for certain types (e.g. outbound, emails, telephone, etc.)
     */
    function NonHtmlAnchorClickTracking(analytics) {
        var _this = this;
        this.analytics = analytics;
        var onAnchorClick = function (ev) {
            var target = ev.currentTarget;
            if (!(target instanceof HTMLAnchorElement)) {
                return;
            }
            var element = target;
            var category = _this.determineLinkEventCategory(element);
            if (category !== null) {
                analytics.trackEvent(category + " Link", "Click", element.href, 0, false // nonInteraction
                );
            }
        };
        // Tracks links that Google Analytics normally does not track
        var anchors = document.getElementsByTagName("a");
        for (var i = 0; i < anchors.length; i++) {
            anchors[i].addEventListener("click", onAnchorClick, false);
        }
    }
    /**
     * @private
     * Return of null would likely indicate an internal link that is html
     */
    NonHtmlAnchorClickTracking.prototype.determineLinkEventCategory = function (element) {
        if (element.href === undefined || element.href === null || element.href.length === 0) {
            return null;
        }
        var protocol = element.protocol === undefined ? "" : element.protocol.toLowerCase();
        var hostname = element.hostname === undefined ? "" : element.hostname.toLowerCase();
        var pathname = element.pathname === undefined ? "" : element.pathname.toLowerCase();
        if (protocol.indexOf("http") === 0) {
            if (this.isOutboundHostname(hostname)) {
                return "Outbound";
            }
            else {
                var extIndexOf = pathname.lastIndexOf(".");
                if (extIndexOf !== -1) {
                    var ext = pathname.substring(extIndexOf + 1);
                    if (ext !== "html"
                        && ext !== "htm"
                        && ext !== "php"
                        && ext !== "asp") {
                        return "Download";
                        // TODO, should this be renamed away from "Download"? Because it is not necassarily a download. Its more just not a standard HTML file.
                    }
                }
            }
        }
        else if (protocol === "mailto:") {
            return "Email";
        }
        else if (protocol === "tel:") {
            return "Telephone";
        }
        else if (protocol === "ftp:") {
            return "FTP";
        }
        else if (protocol === "file:") {
            return "File";
        }
        return null;
    };
    NonHtmlAnchorClickTracking.prototype.isOutboundHostname = function (hostname) {
        var hostnames = this.analytics.getHostnames();
        if (hostnames === undefined)
            return true;
        return hostname.length !== 0 && !this.inArray(hostname, hostnames);
    };
    NonHtmlAnchorClickTracking.prototype.inArray = function (item, list) {
        for (var i = 0; i < list.length; i++) {
            if (list[i] === item) {
                return true;
            }
        }
        return false;
    };
    return NonHtmlAnchorClickTracking;
}());
exports.default = NonHtmlAnchorClickTracking;
